import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import ValidationMessageList from '../../../validation/component/ValidationMessageList'
import LabelInput from '../../../form/component/LabelInput'
import Select from '../../../form/component/Select'
import currentUserHasAccess from '../../../../util/widget-helper'
import { COMPLEXITY_TREATMENT_WIDGET } from '../../../process/ui-definition/process-ui'

const COMPLEXITY_LIST = [
    {
        id: 'simple',
        value: 'Simple',
    },
    {
        id: 'medium',
        value: 'Medium',
    },
    {
        id: 'complex',
        value: 'Complex',
    },
    {
        id: 'joker',
        value: 'Joker',
    },
]

const ComplexityTreatmentWidget = ({
    validationMessageList,
    treatmentPlanObject,
    treatmentPlanExists,
    changeTreatmentPlan,
    saveTreatmentPlan,
    changeProcessContext,
    saveProcessContext
}) => {
    if (!currentUserHasAccess(COMPLEXITY_TREATMENT_WIDGET)) {
        return null
    }

    const complexityName = 'complexity'

    if (treatmentPlanExists && treatmentPlanObject.complexity === null && treatmentPlanObject.iprPossible === true) {
        changeTreatmentPlan(complexityName, 'medium')
        saveTreatmentPlan()
    }

    return (
        <ContentBox title="Treatment plan complexity">
            <Row>
                <Column size={12}>
                    <ValidationMessageList validationMessageList={validationMessageList}/>
                </Column>
            </Row>
            <Row top="M">
                <Column size={6}>
                    <LabelInput label="Complexity">
                        <Select
                            name={complexityName}
                            object={treatmentPlanObject}
                            valueList={COMPLEXITY_LIST}
                            addEmpty={true}
                            readOnly={false}
                            onChange={(name, value) => {
                                if (treatmentPlanExists) {
                                    changeTreatmentPlan(name, value)
                                    saveTreatmentPlan()
                                } else {
                                    changeProcessContext(name, value)
                                    saveProcessContext()
                                }
                            }}
                        />
                    </LabelInput>
                </Column>
                <Column size={6}/>
            </Row>
        </ContentBox>
    )
}

ComplexityTreatmentWidget.propTypes = {
    treatmentPlanObject: PropTypes.object,
    treatmentPlanExists: PropTypes.bool,
    changeTreatmentPlan: PropTypes.func.isRequired,
    saveTreatmentPlan: PropTypes.func.isRequired,
    changeProcessContext: PropTypes.func.isRequired,
    saveProcessContext: PropTypes.func.isRequired,
    validationMessageList: PropTypes.array.isRequired,
}

export default ComplexityTreatmentWidget



// WEBPACK FOOTER //
// ./src/modules/process/component/task-widget/ComplexityTreatmentWidget.js